<style lang="less" scoped>
.pa-3 {
  padding: 12px;
}
.vuetify-disabled {
  color: #BDBDBD;
  text-decoration:line-through;  
}
</style>
<template>
  <div>
    <!-- hide-default-footer -->
    <v-data-table
      ref="test"
      :headers="tableFields"
      :items="tableList"
      :loading="tableLoading"
      :items-per-page="Infinity"
      loading-text="数据加载中..."
      hide-default-footer
    >
      <template v-slot:top>
        <div>
          <v-row>
            <v-col
              v-if="showSearch"
              cols="4"
            >
              <v-text-field
                v-model="params.search"
                append-icon="mdi-magnify"
                :placeholder="searchPlacehold"
                single-line
                hide-details
                clearable
                @click:append="search"
                @click:clear="clearSearch"
                @keydown.enter="search"
              />
            </v-col>
            <v-col style="display: flex;align-items: center">
              <v-btn
                small
                depressed
                color="primary"
                dark
                @click="addNew"
              >
                新增条目
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:no-data>
        <div>
          暂无数据
        </div>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <span
          :class="{
            'vuetify-disabled':item.del
          }"
        >{{ item.name }}</span>
      </template>
      <template
        v-if="propsParams.needSynonyms"
        v-slot:[`item.synonyms`]="{ item }"
      >
        <span>{{ item.synonyms||'-' }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          depressed
          x-small
          dark
          color="primary"
          style="margin-right:10px"
          @click="editItem(item)"
        >
          编辑
        </v-btn>
        <v-btn
          depressed
          x-small
          dark
          :color="item.del?'primary':'warning'"
          @click="deleteItem(item)"
        >
          {{ item.del?'启用':'废弃' }}
        </v-btn>
      </template>
    </v-data-table>
    <EditModal
      ref="expenseNatureModal"
      :loading="propsParams.saveLoading"
      :enter-submit="propsParams.enterSubmit"
      :need-synonyms="!!propsParams.needSynonyms"
      :field-name="propsParams.editModalField"
      @ok="save"
    />
    <CommonModal
      ref="commonModal"
      :loading="propsParams.changeStatusLoading"
      @ok="setStatus"
    />
    <div
      v-if="propsParams.needPageInfor"
      class="line paginate-fix-bottom"
      style="padding-top:0px;padding-bottom:0px;"
    >
      <BczPagination 
        :total="pageInfor.total_count"
        :page-size="pageInfor.per_page"
        :current="pageInfor.cur_page"
        :size-arr="[10,20,50]"
        @pageChange="pageChange"
        @changePageSize="changePageSize"
      />
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { NAME_SPACE } from './../constants'
  import EditModal from './EditModal'
  import CommonModal from './CommonModal'
  import BczPagination from './BczPagination'
  export default {
    components: {
      EditModal,
      CommonModal,
      BczPagination
    },
    props: {
      propsParams:{
        type:Object,
        default:() => ({})
      },
      showSearch: {
        type: Boolean,
        default: false
      },
      searchPlacehold: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        selectedItem:null,
        params: {
          search: null
        }
      }
    },
    computed: {
      ...mapState(NAME_SPACE, {
        natureList:'natureList',
        loading:'loading',
        pageInfor: 'pageInfor'
      }),
      tableFields() {
        return this.propsParams.tableFields
      },
      tableList() {
        return this.propsParams.tableList
      },
      tableLoading() {
        return this.propsParams.tableLoading
      }
    },
    methods:{
      clearSearch() {
        this.params.search = null
        this.$nextTick(() => {
          this.search()
        })
      },
      addNew() {
        const params = {
          name:''
        }
        if (this.propsParams.needSynonyms) {
          params.synonyms = []
        }
        this.$refs.expenseNatureModal.show(params)
      },
      editItem(item) {
        const itemClone = { ...item }
        if (this.propsParams.needSynonyms) {
          itemClone.synonyms = itemClone.synonyms && itemClone.synonyms.split(',') || []
        }
        this.$refs.expenseNatureModal.show(itemClone)
      },
      deleteItem(item) {
        this.$refs.commonModal.show({props:item, title:item.del ? '确定启用？' : '确定废弃？'})
      },
      setStatus({id, del}) {
        this.propsParams.changeStatus({id, success:() => {
          this.$Message.success({
            content: del ? '启用成功' : '废弃成功',
            duration:0.9
          })
          this.$refs.commonModal.cancel()
        }})
      },
      save({id, name, success, synonyms} = {}) {
        const params = { id, name, success }
        if (this.propsParams.needSynonyms) {
          params.synonyms = (synonyms || []).join(',')
        }
        this.propsParams.addAndEdit(params)
      },
      pageChange(page) {
        this.propsParams.getData({
          ...this.pageInfor,
          cur_page:page
        })
      },
      changePageSize(pageSize) {
        this.propsParams.getData({
          ...this.pageInfor,
          per_page:pageSize,
          cur_page:1
        })
      },
      search() {
        this.propsParams.getData({
          ...this.pageInfor,
          ...this.params,
          cur_page:1
        })
      }
    },
  }
</script>
